var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.509 24.969"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 224194"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 1",
  d: "M15.089 24.219h9.67"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 3",
  d: "M13.799 2.022a2.993 2.993 0 0 1 4.155-.4l2.311 1.8a2.856 2.856 0 0 1 .96 3.978c-.046.062-12.717 15.915-12.717 15.915a2.265 2.265 0 0 1-1.749.847l-4.853.061-1.089-4.631a2.172 2.172 0 0 1 .422-1.86Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 5",
  d: "m11.453 4.963 7.27 5.583"
}))));
export default SvgEdit;